module.exports = __webpack_public_path__ + "static/media/doubleDog2.a64df74a.png";